<template>
	<div class="Connect">
		<!--  -->
		<div class="centered" v-if="isSubmitting">
			<div class="is-loading mb-4"></div>
			<div class="">
				Sedang memuat, mohon untuk tidak menutup window ini!
			</div>
		</div>
	</div>
</template>
<script>
import { getAxiosErrorMessage } from '@/lib/helper';
import userApi from '@/api/user';
import statisticApi from '@/api/statistic';
import dropshipApi from '@/api/dropship';

export default {
	name: 'ConnectionCallback',
	data() {
		return {
			isSubmitting: false,
			category: false,
			sub_category: false,
			sub_sub_category: false,
		};
	},
	methods: {
		backToOpener() {
			if (window.opener) {
				window.opener.focus();
				window.opener.location.reload(false);
			}
			window.close();
		},
		connect() {
			this.isSubmitting = true;
			const params = {
				secret_token: this.$route.query.secret_token,
				source_id: this.$route.query.source_id,
				source: this.$route.query.source,
				token: this.$route.query.token,
				name: this.$route.query.name,
				meta: this.$route.query.meta,
			};
			const callback = () => {
				// this.isSubmitting = false;
				localStorage.setItem('oo_token', params.secret_token);
				this.getStatisticCategories('category');
				// this.getStatisticCategories('sub_category');
				// this.getStatisticCategories('sub_sub_category');
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error',
					text: message,
				});
				this.isSubmitting = false;
			};
			if (!this.isSubmiting) {
				userApi.connect(params, callback, errorCallback);
			}
		},
		getStatisticCategories(type) {
			this.isSubmitting = true;
			const params = {
				type,
			};
			const callback = (response) => {
				const categories = response.data;
				this.setStatisticCategories(categories, type);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.isSubmitting = false;
				this.backToOpener();
			};
			dropshipApi.getStatisticCategories(params, callback, errorCallback);
		},
		setStatisticCategories(categories, type) {
			this.isSubmitting = true;
			const params = {
				categories,
			};
			const callback = () => {
				this.isSubmitting = false;
				this.validateCategories(type);
				// this.backToOpener();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.isSubmitting = false;
				this.backToOpener();
			};
			statisticApi.setStatisticCategories(params, callback, errorCallback);
		},
		validateCategories(type) {
			if (type === 'category') this.category = type;
			if (type === 'sub_category') this.sub_category = type;
			if (type === 'sub_sub_category') this.sub_sub_category = type;

			if (this.category && this.sub_category && this.sub_sub_category) {
				this.isSubmitting = false;
				this.backToOpener();
			}
		},
	},
	created() {
		this.connect();
	},
};
</script>
<style scoped>
.centered {
	position: fixed; /* or absolute */
	top: 40%;
	left: 30%;
}
</style>
